import styles from "./index.module.css";
import classNames from "classnames";
import Loader from "shared/Loader";

/**
 * A container element that shows a loader and blocks interaction
 * with its children while `isLoading` is true.
 */
export default function LoadingContainer({ isLoading, children }) {
  return (
    <div className={styles.container}>
      <div
        className={classNames(styles.content, {
          [styles.faded]: isLoading,
        })}
      >
        {children}
      </div>
      {isLoading && (
        <div className={styles.loader}>
          <Loader />
        </div>
      )}
    </div>
  );
}
